<app-loading [loading]="loading"></app-loading>
<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Pagina="Visualizar"
      [TemPaginaPai]="true"
      LinkPaginaPai="/juridico/processo"
      PaginaPai="Processos"
    ></app-breadcrumb>

    <div class="row no-print">
      <div class="col-md-12 mb-2 d-flex justify-content-end">
        <button class="btn btn-default mr-2" (click)="voltar()"><i class="fa fa-arrow-left"></i> Voltar</button>
        <button class="btn btn-primary" (click)="imprimir()"><i class="fa fa-print"></i> Imprimir</button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card" style="min-height: 500px">
          <div class="card-body">
            <div class="row" style="min-height: 150px">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <h2 class="text-blue">{{processo.titulo}}</h2>
                    <div class="info-gerais">
                      Processo | {{processo.numeroProcesso}}
                      <br>Pasta: {{processo.pastaNome}}
                      <br>Cliente: {{processo.cliente}}
                      <br>Status: <span *ngIf="processo.status == 0">Aberto</span>
                      <span *ngIf="processo.status == 1">Oficio</span>
                      <span *ngIf="processo.status == 2">Fechado</span>
                      <span *ngIf="processo.status == 3">Aguardando sentença</span>
                      <span *ngIf="processo.status == 4">Aguardando audiência</span>
                      <span *ngIf="processo.status == 5"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-8">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <div class="card card-blue card-outline">
                      <div class="card-header">
                        <h3 class="card-title"><i class="fa fa-balance-scale"></i> Detalhes do processo</h3>
                        <div class="card-tools">
                          <button type="button" class="btn btn-tool" data-card-widget="collapse">
                            <i class="fa fa-minus"></i>
                          </button>
                        </div>
                      </div>
                      <div class="card-body" style="display: block;">
                        <div class="row">
                          <div class="form-group col-md-12 mb-3">
                            <label>Outros envolvidos</label>
                            <div class="form-control-plaintext">{{processo.nomeOutraParte || '-'}}</div>
                          </div>
                          <div class="col-md-5 mb-3">
                            <label>Número do Processo</label>
                            <div class="form-control-plaintext">{{processo.numeroProcesso || '-'}}</div>
                          </div>
                          <div class="col-md-7 mb-3">
                            <label>Título</label>
                            <div class="form-control-plaintext">{{processo.titulo || '-'}}</div>
                          </div>
                          <div class="col-md-6 mb-3">
                            <label>Valor Causa</label>
                            <div class="form-control-plaintext">{{processo.valorCausa || '-'}}</div>
                          </div>
                          <div class="col-md-6 mb-3">
                            <label>Valor Condenação</label>
                            <div class="form-control-plaintext">{{processo.valorCondenacao || '-'}}</div>
                          </div>
                          <div class="col-md-8 mb-3">
                            <label>Juiz</label>
                            <div class="form-control-plaintext">{{processo.juiz || '-'}}</div>
                          </div>
                          <div class="col-md-4 mb-3">
                            <label>Ação</label>
                            <div class="form-control-plaintext">{{processo.tipoAcaoNome || processo.tipoAcao || '-'}}</div>
                          </div>
                          <div class="col-md-12 mb-3">
                            <label>Objeto</label>
                            <div class="border rounded p-2" [innerHTML]="processo.descricao"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 mb-3">
                    <div class="card card-blue card-outline">
                      <div class="card-header">
                        <h3 class="card-title"><i class="fa fa-exchange"></i> Histórico de Movimentações</h3>
                        <div class="card-tools">
                          <button type="button" class="btn btn-tool" data-card-widget="collapse">
                            <i class="fa fa-minus"></i>
                          </button>
                        </div>
                      </div>
                      <div class="card-body" style="display: block;">
                        <div class="row">
                          <div class="col-md-12" *ngFor="let item of processo.movimentacoes">
                            {{item.dataCadastro | date: 'dd/MM/yyyy HH:mm:ss'}} - {{item.usuarioNome}} - Tipo de movimentação: {{item.tipoNome}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <div class="card card-blue card-outline">
                      <div class="card-header">
                        <h3 class="card-title"><i class="fa fa-file-word-o"></i> Documentos</h3>
                        <div class="card-tools">
                          <span class="badge bg-blue">{{ processo.totalDocumentos }}</span>
                          <button type="button" class="btn btn-tool" data-card-widget="collapse">
                            <i class="fa fa-minus"></i>
                          </button>
                        </div>
                      </div>
                      <div class="card-body" style="display: block;">
                        <table class="table table-bordered table-striped">
                          <tbody *ngIf="processo.totalDocumentos > 0">
                          <tr *ngFor="let item of processo.documentos">
                            <td>
                              <div class="row" style="cursor:default;">
                                <div class="col-md-9">{{item.descricao}}</div>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                          <tbody *ngIf="processo.totalDocumentos <= 0">
                          <tr>
                            <td>Sem documentos cadastrados</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 mb-3">
                    <div class="card card-blue card-outline">
                      <div class="card-header">
                        <h3 class="card-title"><i class="fa fa-check-circle-o"></i> Tarefas</h3>
                        <div class="card-tools">
                          <span class="badge bg-blue">{{ processo.totalTarefas }}</span>
                          <button type="button" class="btn btn-tool" data-card-widget="collapse">
                            <i class="fa fa-minus"></i>
                          </button>
                        </div>
                      </div>
                      <div class="card-body" style="display: block;">
                        <table class="table table-bordered table-striped">
                          <tbody *ngIf="processo.totalTarefas > 0">
                          <tr *ngFor="let item of processo.tarefas">
                            <td>
                              {{item.dataCadastro | date:'dd-MM-yyyy'}} | {{item.descricao}} | Responsável: {{item.responsavel}}
                            </td>
                          </tr>
                          </tbody>
                          <tbody *ngIf="processo.totalTarefas <= 0">
                          <tr>
                            <td>Sem tarefas cadastradas</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 mb-3">
                    <div class="card card-blue card-outline">
                      <div class="card-header">
                        <h3 class="card-title"><i class="fa fa-check-circle-o"></i> Atendimentos</h3>
                        <div class="card-tools">
                          <span class="badge bg-blue">{{ processo.totalAtendimentos }}</span>
                          <button type="button" class="btn btn-tool" data-card-widget="collapse">
                            <i class="fa fa-minus"></i>
                          </button>
                        </div>
                      </div>
                      <div class="card-body" style="display: block;">
                        <table class="table table-bordered table-striped">
                          <tbody *ngIf="processo.totalAtendimentos > 0">
                          <tr *ngFor="let item of processo.atendimentos">
                            <td>
                              {{item.dataCadastro | date:'dd-MM-yyyy'}} | {{item.descricaoResumida}}
                            </td>
                          </tr>
                          </tbody>
                          <tbody *ngIf="processo.totalAtendimentos <= 0">
                          <tr>
                            <td>Sem atendimentos cadastrados</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </section>
</div>
